import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../AuthContext";

export default function Logout() {
  const history = useHistory();

  const { logoutUser } = useContext(AuthContext);

  logoutUser();

  history.push("/");

  return <></>;
}
